import React from "react";
import PropTypes from "prop-types";

import TabBar from "./TabBar";
import { EntryBrandingProvider, EntryBrandingIdentity, EntryBrandingLanguage } from "../../features/entryFlow/EntryBranding";
import "../../styles/app-footer.scss";
import { ScrollProvider } from "../../hooks/useScrollObserver";
import { ApiProvider } from "../../hooks/useApi";

import { ModalsProvider } from "../../hooks/useModal";
import modals from "../modals";
import { AdsProvider } from "../../hooks/useAds";
import { ThemeProvider } from "../../hooks/useTheme";

const Layout = ({ children }) => {
  return (
    <ApiProvider>
      <ThemeProvider>
        <AdsProvider>
          <EntryBrandingProvider>
            <ModalsProvider modals={modals}>
              <ScrollProvider className="layout">
                <TabBar />
                <main>
                  <EntryBrandingIdentity />
                  <div className="entry-branding__content">{children}</div>
                  <EntryBrandingLanguage />
                </main>
                <footer className="app-footer">
                  <div>
                    {`© ${new Date().getFullYear()}, Built by `}
                    <a href="https://contacto.millsonic.com/?utm_source=millsonicweb">Millsonic</a>
                    <span>{process.env.REACT_APP_VERSION ? ` v${process.env.REACT_APP_VERSION}` : ""}</span>
                  </div>
                </footer>
              </ScrollProvider>
            </ModalsProvider>
          </EntryBrandingProvider>
        </AdsProvider>
      </ThemeProvider>
    </ApiProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
